"use strict";

class UserState {

  constructor()
  {
    this.key = 'user_state';
  }

  // localStorageから取り出す
  get() {
    let string = localStorage.getItem(this.key);
    if (!string || string == '') {
      string = '{}';
    }
    return JSON.parse(string);
  }

  // localStorageに保存
  set(json) {
    return localStorage.setItem(this.key, JSON.stringify(json));
  }

  // 指定したプロパティの値を確認
  getProperty(property) {
    const json = this.get();
    return  json[property];
  }

  // 指定したプロパティに値を保存
  setProperty(property, value) {
    const json = this.get();
    json[property] = value;
    return this.set(json);
  }

  // 指定したプロパティを削除
  clearProperty(property) {
    const json = this.get();
    delete json[property]
    return this.set(json);
  }

  // すべてのプロパティを削除
  clearAll() {
    return this.set({});
  }
} 